// extracted by mini-css-extract-plugin
export var closeButton = "_ix-2";
export var closeButtonIcon = "_ix-3";
export var lightboxContent = "_ix-1";
export var lightboxOverlay = "_ix-0";